import { Box, styled } from '@mui/material';

const CarouselContainer = styled(Box, {
  name: 'carousel-container',
  slot: 'Root',
})(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  alignContent: 'center',
  justifyContent: 'space-between',
  height: '100%',
  width: '100%',
  marginTop: '18px',
  overflow: 'hidden',
}));

const SlideWrapper = styled(Box, {
  name: 'slide-wrapper',
  slot: 'Root',
})(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  alignContent: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  gap: '16px',
}));

export { CarouselContainer, SlideWrapper };
